/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Value Object for holding any size related params.
 */
export class SizeVO {

	public width: number;
	public height: number;
	public x: number;
	public y: number;
	public top: number;
	public left: number;
	public bottom: number;
	public right: number;

	/**
	 * @param width
	 * @param height
	 * @param x
	 * @param y
	 * @param top
	 * @param left
	 * @param bottom
	 * @param right
	 */
	constructor(
		width: number = NaN,
		height: number = NaN,
		x: number = NaN,
		y: number = NaN,
		top: number = NaN,
		left: number = NaN,
		bottom: number = NaN,
		right: number = NaN
	) {
		this.width = width;
		this.height = height;
		this.x = x;
		this.y = y;
		this.top = top;
		this.left = left;
		this.bottom = bottom;
		this.right = right;
	}

}